module.exports = __webpack_public_path__ + "img/arrow-right-tail.16d68f48.svg";